import { api, monitoredRequest, formRequest, noMonitor } from "./api";

export const transcribeAudio = async (file: any) => {
  console.log('getting ai response', file._parts)
  return await formRequest.post("/ai/transcribe-meeting", file).catch(()=>{
    
  })
}

export const verifyOCR = async (data: any) => {
  return await noMonitor.post("/ai/verify-ocr", data)
  .then((res) => {
    console.log('OCR verification response:', res);
    return res;
  })
  .catch((error) => {
    console.error('Error in verifyOCR:', error);
    throw new Error('Failed to verify OCR data');
  });
}